// extracted by mini-css-extract-plugin
export default {"sso":"SsoLayout_sso__UZtJC"};